import { Analytics } from '@/components/admin/Analytics';
import { AdminBreadcrumb } from '@/components/AdminBreadcrumb';
import { useSEO } from '@/hooks/useSEO';

export default function AdminAnalyticsPage() {
  useSEO({
    title: 'Analytics Dashboard - Admin Tools',
    description: 'View comprehensive analytics and statistics for the chess application including user engagement and performance metrics.',
    canonical: '/admin/analytics',
    robots: 'noindex, nofollow'
  });

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-900 via-purple-950/95 to-slate-950">
      <AdminBreadcrumb 
        title="Analytics Dashboard" 
        description="Comprehensive analytics and performance metrics for the chess application."
      />
      
      <div className="max-w-7xl mx-auto p-8">
        <Analytics />
      </div>
    </div>
  );
}